export const initialCollectionMethodChoiceEnabled =
  Boolean(process.env.GATSBY_INITIAL_DELIVERY_METHOD_CHOICE_ENABLED) || false
